import React from "react";
import "./Blogs.css";
import ReactDOM from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import Contact from "../../Components/LandingPageSections/Contact";
import Footer from "../../Components/Layout/Footer";
import Navbar from "../../Components/Navbar/Navbar";
import { Link } from "react-router-dom";

function Blogs() {
  return (
    <div className="blogs">
      <Link to="/">
        <div className="blog-logo">
          <img src="/img/logo1.png" width="200px" height="50px"></img>
        </div>
      </Link>
      <div className="blogs_section mt-[50px]">
        <a href="furits">
          <div className="blog_card">
            <div className="img_part">
              <img src="/img/apple-orange.jpg"></img>
            </div>
            <div className="content_part">
              <p className="shoulde_dite">15 Dec | 2020</p>
              <h4 className="heading_dite">
                All Surgeries are not created equal!
              </h4>
              <p className="furit_text">Apples to Oranges</p>
            </div>
            <div className="shoulde_process">
              <div className="shoudle_logo">
                <img src="img/second-blog.png"></img>
                <p className="bolg_card_p">SecondlookOrtho</p>
              </div>
              <div className="date">
                <div className="months_date">
                  <FontAwesomeIcon icon={faClock} />
                  <span className="spandate">8 months ago</span>
                </div>
                <div className="months_date">
                  <FontAwesomeIcon icon={faEnvelope} />
                  <span className="mass-num">2</span>
                </div>
              </div>
            </div>
          </div>
        </a>
        <a href="intro">
          <div className="blog_card">
            <div className="img_part">
              <img src="/img/blog22.png"></img>
            </div>
            <div className="content_part">
              <p className="shoulde_dite">25 Nov | 2020</p>
              <h4 className="heading_dite">Welcome to SecondLookOrtho!</h4>
              <p className="furit_text">Introduction</p>
            </div>
            <div className="shoulde_process">
              <div className="shoudle_logo">
                <img src="img/second-blog.png"></img>
                <p className="bolg_card_p">SecondlookOrtho</p>
              </div>
              <div className="date">
                <div className="months_date">
                  <FontAwesomeIcon icon={faClock} />
                  <span className="spandate">8 months ago</span>
                </div>
                <div className="months_date">
                  <FontAwesomeIcon icon={faEnvelope} />
                  <span className="mass-num">6</span>
                </div>
              </div>
            </div>
          </div>
        </a>
        <a href="latestPost">
          <div className="widget latest-posts">
            <header className="widget-header">
              <h6 className="weight-header-h3">Latest Posts</h6>
            </header>
            <div className="blog-posts">
              <div className="weight-let-post">
                <div className="weight-divs">
                  <div className="apple-weight">
                    <img src="/img/apple-orange.jpg"></img>
                  </div>
                  <div className="weight-tittle">
                    All Surgeries are not created equal!
                  </div>
                </div>
                <div className="months_date-weight">
                  <FontAwesomeIcon icon={faEnvelope} />
                  <span className="mass-num">6</span>
                </div>
              </div>
              <div className="weight-let-post">
                <div className="weight-divs">
                  <div className="apple-weight">
                    <img src="/img/blog22.png"></img>
                  </div>
                  <div className="weight-tittle">
                    Welcome to SecondLookOrtho!
                  </div>
                </div>
                <div className="months_date-weight">
                  <FontAwesomeIcon icon={faEnvelope} />
                  <span className="mass-num">6</span>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
      <Contact />
      <Footer />
    </div>
  );
}

export default Blogs;
